export const DEFAULT_QUOTATION_COLUMNS = {
  col1: 'Particulars',
  col2: 'Colour / Type',
  col3: 'Warranty',
  col4: 'Amount (₹)'
};

export const DEFAULT_QUOTATION_ROW = {
  particulars: '',
  colourType: '',
  warranty: '',
  amount: ''
};
